import { Switch, Route } from "react-router-dom";
import { AppRoutes, RouterPaths } from "@ugg/shared/routes/app-routes";
import { TierList } from "@ugg/shared/components/TierList/pages/Default/TierList";
import { CombatTierListContainer } from "@ugg/shared/components/TierList/pages/Combat/CombatTierListContainer";
import { ObjectivesTierListContainer } from "@ugg/shared/components/TierList/pages/Objectives/ObjectivesTierListContainer";
import { DuoTierListContainer } from "@ugg/shared/components/TierList/pages/Duo/DuoTierListContainer";
import { ArenaTierListContainer } from "@ugg/shared/components/TierList/pages/Arena/ArenaTierListContainer";
import { ArenaDuoTierListContainer } from "@ugg/shared/components/TierList/pages/Arena/ArenaDuoTierListContainer";
import {
  AramMayhemChampionTierListContainer,
  AramMayhemAugmentTierListContainer,
  AramMayhemAugmentTierListByRarityContainer,
} from "@ugg/shared/components/TierList/pages/AramMayhem/AramMayhemTierListContainer";
import { ClassicChampionTierListContainer } from "@ugg/shared/components/TierList/pages/Classic/ClassicTierListContainer";
import StickyNewsBanner, { PatchNotesCTAButton } from "components/TierList/TierListNewsBanner";

const patchNotesCTA = <PatchNotesCTAButton />;
const mobileBannerSlot = <StickyNewsBanner className="sm:hidden" />;

export const TierListRoutes = () => {
  return (
    <Switch>
      <Route
        path={AppRoutes.ARENA_TIER_LIST}
        render={() => <ArenaTierListContainer patchNotesCTA={patchNotesCTA} bannerSlot={mobileBannerSlot} />}
      />
      <Route
        path={AppRoutes.ARENA_DUO_TIER_LIST}
        render={() => <ArenaDuoTierListContainer patchNotesCTA={patchNotesCTA} bannerSlot={mobileBannerSlot} />}
      />
      <Route
        path={AppRoutes.DUO_TIER_LIST}
        render={() => <DuoTierListContainer patchNotesCTA={patchNotesCTA} bannerSlot={mobileBannerSlot} />}
      />
      <Route
        path={AppRoutes.COMBAT_TIER_LIST}
        render={() => <CombatTierListContainer patchNotesCTA={patchNotesCTA} bannerSlot={mobileBannerSlot} />}
      />
      <Route
        path={AppRoutes.OBJECTIVES_TIER_LIST}
        render={() => <ObjectivesTierListContainer patchNotesCTA={patchNotesCTA} bannerSlot={mobileBannerSlot} />}
      />
      <Route
        path={AppRoutes.CLASSIC_TIER_LIST}
        render={() => <ClassicChampionTierListContainer patchNotesCTA={patchNotesCTA} bannerSlot={mobileBannerSlot} />}
      />
      <Route
        path={AppRoutes.ARAM_MAYHEM_TIER_LIST}
        render={() => <AramMayhemChampionTierListContainer patchNotesCTA={patchNotesCTA} bannerSlot={mobileBannerSlot} />}
      />
      <Route
        path={AppRoutes.ARAM_MAYHEM_AUGMENT_TIER_LIST}
        render={() => <AramMayhemAugmentTierListByRarityContainer patchNotesCTA={patchNotesCTA} bannerSlot={mobileBannerSlot} />}
      />
      <Route
        path={RouterPaths.TIER_LIST}
        render={() => <TierList patchNotesCTA={patchNotesCTA} bannerSlot={mobileBannerSlot} />}
      />
    </Switch>
  );
};
